import {useRef} from 'react'
import {Form} from 'antd'
import Alert from './Alert.jsx'
import Modal from './Modal.jsx'
import {useOpenModal} from './ModalManagerContext.mjs'

const defaultValidate = async values => {}

export default function Prompt({
    children,
    formProps,
    validate = defaultValidate,
    value,
    onOk,
    ...props
}) {
    const openModal = useOpenModal()
    const [form] = Form.useForm()
    const refValue = useRef()

    if (value !== refValue.current) {
        refValue.current = value
        form.setFieldsValue(value)
    }

    const handleFinish = async values => {
        try {
            await validate(values)
        }
        catch (err) {
            await openModal(<Alert type="error">{err.message}</Alert>)
            throw err
        }

        onOk(values)
    }

    const handleOk = () => form.submit()

    return (
        <Modal
            onOk={handleOk}
            {...props}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleFinish}
                {...formProps}
            >
                {children}
            </Form>
        </Modal>
    )
}
